/* Reuse Napoleon's actual player, including its mask, controls and defaults. */
const { mountPdpVideo } = await import(document.querySelector('[data-pdp-video-player]')?.dataset.pdpVideoPlayer || new URL('./napoleon-ui.js',import.meta.url).href);
function mountVideos(){
  document.querySelectorAll('[data-pdp-vimeo]:not([data-video-mounted])').forEach(host=>{host.dataset.videoMounted='true';mountPdpVideo(host,{vimeoId:host.dataset.pdpVimeo,vimeoHash:host.dataset.vimeoHash,title:host.dataset.videoTitle,pauseOffscreen:true});});
  document.querySelectorAll('[data-napoleon-video]:not([data-video-mounted])').forEach(host=>{
    host.dataset.videoMounted='true';
    mountPdpVideo(host,{youtubeId:host.dataset.napoleonVideo,title:host.dataset.videoTitle,description:host.dataset.videoDescription,pauseOffscreen:host.dataset.videoPauseOffscreen==='true'});
  });
  document.querySelectorAll('.fm-page[data-product-handle^="blackstone-"] .ho-pdp-video:not([data-video-mounted]) video').forEach(media=>{
    const host=media.closest('.ho-pdp-video');
    const sourceUrl=media.currentSrc||media.querySelector('source[type="video/mp4"]')?.src||media.src;
    if(!sourceUrl)return;
    host.dataset.videoMounted='true';
    mountPdpVideo(host,{sourceUrl,poster:media.poster,title:media.getAttribute('aria-label')||'Blackstone video',pauseOffscreen:true});
  });
}
mountVideos();
new MutationObserver(mountVideos).observe(document.getElementById('MainContent')||document.body,{childList:true,subtree:true});
